"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseReferenceExtension = void 0;
const index_js_1 = require("../../../../../errors/index.js");
const index_js_2 = require("../../../../../schema/actions/parse/index.js");
const isArray_js_1 = require("../../../../../utils/validation/isArray.js");
const isString_js_1 = require("../../../../../utils/validation/isString.js");
const index_js_3 = require("../../symbols/index.js");
const parseReferenceExtension = (attribute, inputValue, { transform = true } = {}) => {
    if ((0, index_js_3.isGetting)(inputValue) && inputValue[index_js_3.$GET] !== undefined) {
        return {
            isExtension: true,
            *extensionParser() {
                const references = inputValue[index_js_3.$GET];
                if (!(0, isArray_js_1.isArray)(references)) {
                    const { path } = attribute;
                    throw new index_js_1.DynamoDBToolboxError('parsing.invalidAttributeInput', {
                        message: `References ${path !== undefined ? `for attribute '${path}' ` : ''}should be a tuple of one or two elements`,
                        path,
                        payload: {
                            received: inputValue[index_js_3.$GET]
                        }
                    });
                }
                const [reference, fallback] = references;
                if (!(0, isString_js_1.isString)(reference)) {
                    const { path } = attribute;
                    throw new index_js_1.DynamoDBToolboxError('parsing.invalidAttributeInput', {
                        message: `First elements of references ${path !== undefined ? `for attribute '${path}' ` : ''}should be strings`,
                        path,
                        payload: {
                            received: references[0]
                        }
                    });
                }
                const fallbackParser = fallback !== undefined
                    ? new index_js_2.Parser(attribute).start(fallback, {
                        fill: false,
                        transform,
                        parseExtension: exports.parseReferenceExtension
                    })
                    : undefined;
                const parsedValue = {
                    [index_js_3.$GET]: [
                        // NOTE: Reference validation is done in UpdateExpressionParser
                        reference,
                        ...(fallbackParser !== undefined ? [fallbackParser.next().value] : [])
                    ]
                };
                if (transform) {
                    yield parsedValue;
                }
                else {
                    return parsedValue;
                }
                const transformedValue = {
                    [index_js_3.$GET]: [
                        // NOTE: Reference validation is done in UpdateExpressionParser
                        reference,
                        ...(fallbackParser !== undefined ? [fallbackParser.next().value] : [])
                    ]
                };
                return transformedValue;
            }
        };
    }
    return {
        isExtension: false,
        basicInput: inputValue
    };
};
exports.parseReferenceExtension = parseReferenceExtension;
